// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__3hVi4","loading":"styles_loading__1SKEb","telmexLoading":"styles_telmexLoading__21sU_","spinner":"styles_spinner__1Ugzs"};